import axios from "axios";
// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么

    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response;
  },
  function(error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? "/api"
      : "http://dev-client-api.gongcheng1949.com",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json", // 设置Content-Type头
    Accept: "application/json", // 设置Accept头
    "x-app-platform": "ios", //平台信息
    "x-app-version": "1.0.0", //版本号
    "x-app-lang": "zh-Hans",
    "x-app-token":
      "eyJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50SWQiOjEwMDAwMDEyLCJuYW1lIjpudWxsLCJleHAiOjE3ODc0NTIxMTEsImFjY291bnQiOiIxNTU1NTU1NTU1NSJ9.xZRCc9bx1VTam6ked5Y63t1xYwCgGnm_va1vMMlJNaw" //token
  }
});



// WEBPACK FOOTER //
// ./src/api/index.js